import * as React from "react";
import { cn } from "@/lib/cn";

/**
 * Depth comes from the 1px translucent ring inside `--shadow-card`, not from a
 * drop shadow -- the shadow is near-invisible by design (4% at 2px). That is
 * why cards read as crisp rather than floaty, and why the token has to follow
 * the theme: a hard-coded slate rgba is simply invisible on a dark page.
 */
export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-lg border border-border bg-card text-card-foreground shadow-card", className)}
      {...props}
    />
  );
}

/** The divider is `--border-light`, a step softer than the card's own border,
 *  so the outline stays the strongest line in the composition. */
export function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex items-center justify-between gap-3 border-b border-border-light px-4 py-3", className)} {...props} />;
}

/** An <h2>, not an <h3>: `PageHeader` emits the page's only <h1> and there is
 *  no h2 anywhere else, so every screen would jump a heading level. The SIZE is
 *  unchanged -- heading level is structure, not scale. */
export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn("text-sm font-semibold text-foreground", className)} {...props} />;
}

export function CardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4", className)} {...props} />;
}
